import React from 'react';
import Column from 'canvas-core-react/lib/Column';
// import Margin from 'canvas-core-react/lib/Margin';
import TextHeadline from 'canvas-core-react/lib/TextHeadline';
import TextCaption from 'canvas-core-react/lib/TextCaption';
import Row from 'canvas-core-react/lib/Row';
import Margin from 'canvas-core-react/lib/Margin';
import IconInternationalMoneyTransferIllustrative from 'canvas-core-react/lib/IconInternationalMoneyTransferIllustrative';
import IconDebitCardIllustrative from 'canvas-core-react/lib/IconDebitCardIllustrative';
import IconTransferIllustrative from 'canvas-core-react/lib/IconTransferIllustrative';
import IconOnlineIllustrative from 'canvas-core-react/lib/IconOnlineIllustrative';
// ICONS
import { ReactComponent as Icon } from '../icons/icon_benefitsbanner.svg';

import TextAlign from '../../utils/TextAlign';
// STYLES
import './Banner.scss';
import TextSubtitle from 'canvas-core-react/lib/TextSubtitle';

const BenefitsBanner = () => {

    return (
        <>
            <Column className="benefits-background" lgOffset={1.75} lg={8.5}>
                <TextHeadline size='small' component="h1" className='benefitsbanner'>Beneficios de esta oportunidad imperdible</TextHeadline>
                <Row>
                    <Column xs={2} sm={4} md={6} lg={6} xsHide smHide className='benefitsbanner-icon'>
                        <Icon />
                    </Column>
                    <Column xs={4} sm={4} md={6} lg={6} className="padding-benefits">
                        <Margin side="top" xs={0} sm={0} md={18} lg={18}>
                            <div style={{ display: 'flex', alignItems: 'start' }} className='benefitsbanner_1'>
                                <TextAlign>
                                    <Margin side="top" xs={6} sm={6} md={6} lg={6}>
                                        <IconInternationalMoneyTransferIllustrative size={30} />
                                    </Margin>
                                </TextAlign>
                                <TextSubtitle type='2' component="h1" style={{ textAlign: 'start', marginLeft: '0.6rem', marginRight: '12rem' }} className='benefitsbanner_1'>
                                    Tasa exclusiva
                                    <TextCaption component="p" >
                                        Al tomar este Depósito a Plazo obtendrás una tasa exclusiva con la que siempre ganarás intereses sin un monto máximo de inversión.
                                    </TextCaption>
                                </TextSubtitle>
                                
                            </div>
                        </Margin>
                        <Margin side="top" xs={18} sm={18} md={18} lg={18}>
                            <div style={{ display: 'flex', alignItems: 'start' }}>
                                <TextAlign>
                                    <Margin side="top" xs={6} sm={6} md={6} lg={6}>
                                        <IconDebitCardIllustrative size={30} />
                                    </Margin>
                                </TextAlign>
                                <TextSubtitle type='2' component="h1" style={{ textAlign: 'start', marginLeft: '0.6rem', marginRight: '12rem' }} className='benefitsbanner_1'>
                                    Serás parte de Scotia
                                    <TextCaption component="p">
                                        Te convertirás en cliente y obtendrás una Cuenta Corriente en pesos y en dólares, además de una Tarjeta de Débito digital a costo cero.
                                    </TextCaption>
                                </TextSubtitle>
                            </div>
                        </Margin>

                        <Margin side="top" xs={18} sm={18} md={18} lg={18}>
                            <div style={{ display: 'flex', alignItems: 'start' }}>
                                <TextAlign>
                                    <Margin side="top" xs={6} sm={6} md={6} lg={6}>
                                    <IconTransferIllustrative size={30} />
                                    </Margin>
                                </TextAlign>
                                <TextSubtitle type='2' component="h1" style={{ textAlign: 'start', marginLeft: '0.6rem', marginRight: '12rem' }} className='benefitsbanner_1'>
                                    Paga desde tu banco
                                    <TextCaption component="p" >
                                        Podrás pagar el monto inicial de tu Depósito a Plazo desde cualquier banco.
                                    </TextCaption>
                                </TextSubtitle>
                            </div>
                        </Margin>

                        <Margin side="top" xs={18} sm={18} md={18} lg={18}>
                            <div style={{ display: 'flex', alignItems: 'start' }}>
                                <TextAlign>
                                    <Margin side="top" xs={6} sm={6} md={6} lg={6}>
                                    <IconOnlineIllustrative size={30} />
                                    </Margin>
                                </TextAlign>
                                <TextSubtitle component="h1" type='2' style={{ textAlign: 'start', marginLeft: '0.6rem', marginRight: '12rem' }} className='benefitsbanner_1'>
                                    100% Digital
                                    <TextCaption component="p" >
                                        Realiza tus inversiones desde donde estés de forma rápida y sencilla.
                                    </TextCaption>
                                </TextSubtitle>
                            </div>
                        </Margin>
                    </Column>
                </Row>

            </Column>
        </>

    )
}

export default BenefitsBanner;